import { useLocation, useParams } from 'react-router-dom';

const toSegments = (path: string) => path.split('/').filter(Boolean);

export const useRouteUrl = (): string => {
  const { pathname } = useLocation();
  const { '*': unmatchedPath = '' } = useParams();
  const pathSegments = toSegments(pathname);
  const matchedSegments = pathSegments.slice(
    0,
    pathSegments.length - toSegments(unmatchedPath).length
  );

  return `/${matchedSegments.join('/')}`;
};
